import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Input,
  Text,
  VStack,
  FormControl,
  FormErrorMessage,
} from "@chakra-ui/react";

import "@fontsource/rajdhani/400.css";
import "@fontsource/rajdhani/500.css";
import "@fontsource/rajdhani/600.css";
import "@fontsource/rajdhani/700.css";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD-T24QYmjfoQC6koP-LoZAxxzMZ7wiRAA",
  authDomain: "velocity-protocol-website.firebaseapp.com",
  projectId: "velocity-protocol-website",
  storageBucket: "velocity-protocol-website.firebasestorage.app",
  messagingSenderId: "537076840579",
  appId: "1:537076840579:web:ff8ed7ae70303818fcc3b6",
  measurementId: "G-PM72ZNETVS",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const DOWNLOAD_URL =
  "https://pub-be007b41698b43fb8957f853c7688955.r2.dev/VelocityProtocol_vAlpha.1.0.zip";

export default function Download() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const [windowsOnly, setWindowsOnly] = useState(false);

  const validateEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  const startDownload = () => {
    if (isMobileDevice()) {
      setWindowsOnly(true);
      setDownloaded(true);
      return;
    }

    const link = document.createElement("a");
    link.href = DOWNLOAD_URL;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isMobileDevice = () => {
    if (typeof window === "undefined") return false;

    return (
      /Android|iPhone|iPad|iPod|Mobile/i.test(window.navigator.userAgent) ||
      window.matchMedia("(max-width: 767px)").matches
    );
  };

  const handleDownload = async () => {
    setError("");

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "Emails"), {
        email: email.trim().toLowerCase(),
        timestamp: serverTimestamp(),
        source: "website",
        version: "vAlpha.1.0",
      });

      setDownloaded(true);
      startDownload();
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      bg="#08090C"
      color="white"
      minH="calc(100vh - 64px)"
      fontFamily="'Rajdhani', sans-serif"
    >
      <Box
        position="relative"
        minH="calc(100vh - 64px)"
        display="flex"
        alignItems="center"
        backgroundImage="url('/images/HighresScreenshot00008.png')"
        backgroundSize="cover"
        alt="Velocity Protocol movement shooter gameplay featuring wall running and fast-paced FPS combat"
        backgroundPosition="center"
        px={{ base: 4, md: 6 }}
        py={{ base: 10, md: 28 }}
      >
        <Box position="absolute" inset={0} bg="rgba(0,0,0,0)" />

        <Container maxW="container.md" position="relative" zIndex={1} px={0}>
          <Box
            bg="rgb(0, 0, 0, 0.3)"
            border="1px solid rgba(255,255,255,0.08)"
            borderRadius={{ base: "14px", md: "20px" }}
            p={{ base: 6, md: 12 }}
            textAlign="center"
            backdropFilter="blur(8px)"
          >
            {!downloaded ? (
              <VStack spacing={{ base: 5, md: 7 }}>
                <Text
                  color="gray.400"
                  textTransform="uppercase"
                  letterSpacing={{ base: "0.14em", md: "0.25em" }}
                  fontWeight="700"
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  Velocity Protocol Open Alpha
                </Text>

                <Heading
                  color="white"
                  fontWeight="700"
                  fontSize={{ base: "4xl", md: "7xl" }}
                  lineHeight="0.95"
                  fontFamily="'Rajdhani', sans-serif"
                  textTransform="uppercase"
                >
                  Download
                </Heading>

                <Text
                  color="gray.300"
                  maxW="500px"
                  fontSize={{ base: "md", md: "xl" }}
                  fontWeight="500"
                >
                  Enter your email below to access the latest alpha build and
                  receive future development updates.
                </Text>

                <FormControl isInvalid={!!error} maxW="450px" width="100%">
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email Address"
                    size="lg"
                    bg="whiteAlpha.100"
                    color="white"
                    borderColor="whiteAlpha.300"
                    fontSize="lg"
                    fontWeight="600"
                    _placeholder={{
                      color: "gray.500",
                    }}
                    _hover={{
                      borderColor: "whiteAlpha.500",
                    }}
                    _focus={{
                      borderColor: "white",
                      boxShadow: "0 0 0 1px white",
                    }}
                  />
                  <FormErrorMessage>{error}</FormErrorMessage>
                </FormControl>

                <Button
                  size="lg"
                  bg="white"
                  color="black"
                  onClick={handleDownload}
                  isLoading={loading}
                  px={12}
                  h="56px"
                  width={{ base: "100%", sm: "auto" }}
                  maxW="360px"
                  fontSize={{ base: "md", md: "lg" }}
                  fontWeight="700"
                  letterSpacing="0.08em"
                  textTransform="uppercase"
                  _hover={{ bg: "gray.300" }}
                >
                  Download Alpha Demo
                </Button>

                <Text
                  color="gray.400"
                  fontSize={{ base: "sm", md: "lg" }}
                  fontWeight="600"
                  letterSpacing="0.08em"
                >
                  WINDOWS | vALPHA.1.0 | 0.9GB
                </Text>
              </VStack>
            ) : (
              <VStack spacing={{ base: 5, md: 7 }}>
                <Text
                  color="gray.400"
                  textTransform="uppercase"
                  letterSpacing={{ base: "0.14em", md: "0.25em" }}
                  fontWeight="700"
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  {windowsOnly ? "Email Saved" : "Access Granted"}
                </Text>

                <Heading
                  color="white"
                  fontWeight="700"
                  fontSize={{ base: "4xl", md: "7xl" }}
                  lineHeight="0.95"
                  fontFamily="'Rajdhani', sans-serif"
                  textTransform="uppercase"
                >
                  {windowsOnly ? "Windows Only" : "Starting Download"}
                </Heading>

                <Text
                  color="gray.300"
                  maxW="500px"
                  fontSize={{ base: "md", md: "xl" }}
                  fontWeight="500"
                >
                  {windowsOnly
                    ? "The demo is only available for Windows. Please visit this page on a Windows PC to download the build."
                    : "Your download should begin automatically. Thank you for helping test Velocity Protocol and shape the future of the game."}
                </Text>

                {!windowsOnly && (
                  <Button
                    size="lg"
                    bg="white"
                    color="black"
                    onClick={startDownload}
                    px={12}
                    h="56px"
                    width={{ base: "100%", sm: "auto" }}
                    maxW="360px"
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight="700"
                    letterSpacing="0.08em"
                    textTransform="uppercase"
                    _hover={{ bg: "gray.300" }}
                  >
                    Download Again
                  </Button>
                )}

                <Text
                  color="gray.500"
                  fontSize={{ base: "sm", md: "md" }}
                  fontWeight="600"
                  letterSpacing="0.08em"
                >
                  {windowsOnly
                    ? "NO DOWNLOAD WAS STARTED ON THIS DEVICE"
                    : "CHECK YOUR DOWNLOADS FOLDER IF THE FILE IS NOT VISIBLE"}
                </Text>
              </VStack>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
